var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWiderange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 22.6356C41.41 20.1347 38.65 18.3122 35.48 17.5225C36.31 18.8387 36.97 20.6106 37.46 22.6356H43.4Z",
    fill: "url(#paint0_linear_99_513)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 22.6356H26.54C27.03 20.6106 27.7 18.8387 28.52 17.5225C25.35 18.3122 22.58 20.1347 20.6 22.6356Z",
    fill: "url(#paint1_linear_99_513)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4 41.1644H37.46C36.97 43.1894 36.3 44.9613 35.48 46.2775C38.65 45.4878 41.42 43.6653 43.4 41.1644Z",
    fill: "url(#paint2_linear_99_513)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.59 32.8922H38.49C38.44 35.0387 38.24 37.1852 37.89 39.1799H44.74C45.78 37.2966 46.44 35.1704 46.59 32.8922Z",
    fill: "url(#paint3_linear_99_513)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.52 46.2775C27.69 44.9613 27.03 43.1894 26.54 41.1644H20.6C22.58 43.6653 25.35 45.4878 28.52 46.2775Z",
    fill: "url(#paint4_linear_99_513)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.52 32.8922H27.48C27.53 35.2514 27.75 37.3675 28.09 39.1799H35.9C36.25 37.3675 36.47 35.2514 36.52 32.8922Z",
    fill: "url(#paint5_linear_99_513)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.48 30.9077H36.52C36.47 28.5486 36.25 26.4325 35.91 24.6201H28.1C27.75 26.4325 27.53 28.5486 27.48 30.9077Z",
    fill: "url(#paint6_linear_99_513)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.41 30.9077H25.51C25.56 28.7612 25.76 26.6147 26.11 24.6201H19.26C18.22 26.5034 17.56 28.6296 17.41 30.9077Z",
    fill: "url(#paint7_linear_99_513)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.27 39.1799H26.12C25.77 37.1852 25.56 35.0387 25.52 32.8922H17.42C17.56 35.1704 18.22 37.2966 19.27 39.1799Z",
    fill: "url(#paint8_linear_99_513)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.78 10.111C45.62 11.0931 44.12 11.6905 42.49 11.6905C41.95 11.6905 41.43 11.6196 40.92 11.4981L38.87 16.6214C42.39 18.2515 45.24 21.0865 46.92 24.61L52.11 22.4837C52 22.0079 51.94 21.5117 51.94 20.9954C51.94 19.4159 52.48 17.9579 53.38 16.8036L46.78 10.111Z",
    fill: "url(#paint9_linear_99_513)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.67 27.6981C55.6 27.3842 53.83 26.1186 52.84 24.3467L47.69 26.4527C48.27 28.1639 48.61 29.9965 48.61 31.9101C48.61 33.8237 48.28 35.6564 47.69 37.3675L52.84 39.4735C53.84 37.7016 55.6 36.4259 57.67 36.1221V27.6981Z",
    fill: "url(#paint10_linear_99_513)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.12 41.3162L46.93 39.19C45.25 42.7135 42.4 45.5485 38.88 47.1786L40.93 52.312C41.43 52.1905 41.96 52.1196 42.5 52.1196C44.13 52.1196 45.63 52.717 46.79 53.6991L53.41 46.9964C52.51 45.8421 51.97 44.3942 51.97 42.8046C51.96 42.2882 52.02 41.7921 52.12 41.3162Z",
    fill: "url(#paint11_linear_99_513)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.65 25.7946C61.26 25.7946 63.38 23.6481 63.38 21.0055C63.38 18.3629 61.26 16.2164 58.65 16.2164C56.04 16.2164 53.92 18.3629 53.92 21.0055C53.92 23.638 56.04 25.7946 58.65 25.7946ZM58.65 19.9424C59.23 19.9424 59.69 20.4182 59.69 20.9954C59.69 21.5826 59.22 22.0484 58.65 22.0484C58.07 22.0484 57.61 21.5725 57.61 20.9954C57.6 20.4182 58.07 19.9424 58.65 19.9424Z",
    fill: "url(#paint12_linear_99_513)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 52.1095C21.5 52.1095 22.02 52.1804 22.53 52.3019L24.67 46.9457C21.3 45.2549 18.58 42.4502 16.99 38.9976L11.83 41.1036C11.97 41.6402 12.05 42.2072 12.05 42.7945C12.05 44.374 11.51 45.832 10.61 46.9862L16.99 53.446C18.1 52.6056 19.47 52.1095 20.96 52.1095Z",
    fill: "url(#paint13_linear_99_513)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.82 22.6862L16.98 24.7922C18.58 21.3396 21.3 18.535 24.66 16.8441L22.53 11.4981C22.03 11.6196 21.5 11.6905 20.96 11.6905C19.47 11.6905 18.09 11.1842 16.98 10.354L10.6 16.8137C11.5 17.968 12.04 19.4159 12.04 21.0055C12.04 21.5826 11.96 22.1496 11.82 22.6862Z",
    fill: "url(#paint14_linear_99_513)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.35 10.7489L26.47 16.0746C28.2 15.457 30.06 15.0925 32 15.0925C33.76 15.0925 35.46 15.376 37.05 15.8924L39.1 10.7489C37.39 9.72625 36.18 7.97462 35.87 5.90912H27.56C27.27 7.97462 26.05 9.73637 24.35 10.7489Z",
    fill: "url(#paint15_linear_99_513)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 37.165C15.71 35.5045 15.41 33.7427 15.41 31.9C15.41 30.0572 15.71 28.2955 16.25 26.635L11.06 24.5087C10.05 26.1895 8.33 27.3842 6.33 27.688V36.1019C8.33 36.4056 10.04 37.6004 11.06 39.2811L16.25 37.165Z",
    fill: "url(#paint16_linear_99_513)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.73 24.6201H37.88C38.23 26.6147 38.44 28.7612 38.48 30.9077H46.58C46.44 28.6296 45.78 26.5034 44.73 24.6201Z",
    fill: "url(#paint17_linear_99_513)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.11 53.0511L37.06 47.9076C35.47 48.424 33.77 48.7075 32.01 48.7075C30.07 48.7075 28.21 48.3531 26.48 47.7254L24.36 53.0511C26.07 54.0737 27.28 55.8254 27.59 57.8909H35.9C36.18 55.8254 37.4 54.0636 39.11 53.0511Z",
    fill: "url(#paint18_linear_99_513)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 54.094C18.35 54.094 16.23 56.2405 16.23 58.8831C16.23 61.5257 18.35 63.6722 20.96 63.6722C23.57 63.6722 25.69 61.5257 25.69 58.8831C25.69 56.2405 23.57 54.094 20.96 54.094ZM20.96 59.9361C20.38 59.9361 19.92 59.4602 19.92 58.8831C19.92 58.2959 20.39 57.8301 20.96 57.8301C21.54 57.8301 22 58.306 22 58.8831C22.01 59.4602 21.54 59.9361 20.96 59.9361Z",
    fill: "url(#paint19_linear_99_513)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 38.0155C2.74 38.0155 0.619995 40.162 0.619995 42.8046C0.619995 45.4472 2.74 47.5937 5.35 47.5937C7.96 47.5937 10.08 45.4472 10.08 42.8046C10.08 40.162 7.96 38.0155 5.35 38.0155ZM5.35 43.8576C4.77 43.8576 4.31 43.3817 4.31 42.8046C4.31 42.2174 4.78 41.7516 5.35 41.7516C5.93 41.7516 6.39 42.2275 6.39 42.8046C6.4 43.3817 5.93 43.8576 5.35 43.8576Z",
    fill: "url(#paint20_linear_99_513)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35 25.7946C7.96 25.7946 10.08 23.6481 10.08 21.0055C10.08 18.3629 7.96 16.2164 5.35 16.2164C2.74 16.2164 0.619995 18.3629 0.619995 21.0055C0.619995 23.638 2.75 25.7946 5.35 25.7946ZM5.35 19.9424C5.93 19.9424 6.39 20.4182 6.39 20.9954C6.39 21.5826 5.92 22.0484 5.35 22.0484C4.77 22.0484 4.31 21.5725 4.31 20.9954C4.31 20.4182 4.78 19.9424 5.35 19.9424Z",
    fill: "url(#paint21_linear_99_513)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.49 54.094C39.88 54.094 37.76 56.2405 37.76 58.8831C37.76 61.5257 39.88 63.6722 42.49 63.6722C45.1 63.6722 47.22 61.5257 47.22 58.8831C47.22 56.2405 45.1 54.094 42.49 54.094ZM42.49 59.9361C41.91 59.9361 41.45 59.4602 41.45 58.8831C41.45 58.2959 41.92 57.8301 42.49 57.8301C43.07 57.8301 43.53 58.306 43.53 58.8831C43.54 59.4602 43.07 59.9361 42.49 59.9361Z",
    fill: "url(#paint22_linear_99_513)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M58.65 38.0155C56.04 38.0155 53.92 40.162 53.92 42.8046C53.92 45.4472 56.04 47.5937 58.65 47.5937C61.26 47.5937 63.38 45.4472 63.38 42.8046C63.38 40.162 61.25 38.0155 58.65 38.0155ZM58.65 43.8576C58.07 43.8576 57.61 43.3817 57.61 42.8046C57.61 42.2174 58.08 41.7516 58.65 41.7516C59.23 41.7516 59.69 42.2275 59.69 42.8046C59.69 43.3817 59.22 43.8576 58.65 43.8576Z",
    fill: "url(#paint23_linear_99_513)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 9.706C23.57 9.706 25.69 7.5595 25.69 4.91687C25.69 2.27425 23.57 0.127747 20.96 0.127747C18.35 0.127747 16.23 2.27425 16.23 4.91687C16.23 7.5595 18.35 9.706 20.96 9.706ZM20.96 3.86387C21.54 3.86387 22 4.33975 22 4.91687C22 5.50412 21.53 5.96987 20.96 5.96987C20.38 5.96987 19.92 5.494 19.92 4.91687C19.92 4.33975 20.39 3.86387 20.96 3.86387Z",
    fill: "url(#paint24_linear_99_513)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M32 46.723C33.13 46.723 34.51 44.7182 35.46 41.1745H28.55C29.49 44.7081 30.87 46.723 32 46.723Z",
    fill: "url(#paint25_linear_99_513)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32 17.077C30.87 17.077 29.49 19.0817 28.54 22.6255H35.45C34.51 19.0919 33.13 17.077 32 17.077Z",
    fill: "url(#paint26_linear_99_513)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.49 9.706C45.1 9.706 47.22 7.5595 47.22 4.91687C47.22 2.27425 45.1 0.127747 42.49 0.127747C39.88 0.127747 37.76 2.27425 37.76 4.91687C37.76 7.5595 39.88 9.706 42.49 9.706ZM42.49 3.86387C43.07 3.86387 43.53 4.33975 43.53 4.91687C43.53 5.50412 43.06 5.96987 42.49 5.96987C41.91 5.96987 41.45 5.494 41.45 4.91687C41.45 4.33975 41.91 3.86387 42.49 3.86387Z",
    fill: "url(#paint27_linear_99_513)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_99_513",
    x1: 32,
    y1: 0.127747,
    x2: 32,
    y2: 63.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_99_513",
    x1: 42.49,
    y1: 0.127747,
    x2: 42.49,
    y2: 9.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#495BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55E6A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiderange);
export default __webpack_public_path__ + "static/media/wide range.3cf9a614feb2b6366cd5176348d0de0a.svg";
export { ForwardRef as ReactComponent };